import React from "react";
import { connect } from 'react-redux';
import TextInput from '@zacousticrepo/grommet-v1-custom/components/TextInput';
import RadioButton from '@zacousticrepo/grommet-v1-custom/components/RadioButton';
import { arrayIsNotEmpty, isDefined } from "../../../utils";
//import FormControl from '@material-ui/core/FormControl/FormControl';
//import RadioGroup from '@material-ui/core/RadioGroup/RadioGroup';
//import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
//import Radio from '@material-ui/core/Radio/Radio';

class TeamEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            teamName: undefined
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.closeAndCreate = this.closeAndCreate.bind(this);
        this.selectSurveyFormType = this.selectSurveyFormType.bind(this);

        this.updateName = this.updateName.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        const
            {
                onClose
            } = this.props;

        if (this.wrapperRef) {
            if (!this.wrapperRef.current.contains(event.target)) {
                onClose();
            }
        }
    }

    closeAndCreate() {
        const
            {
                onClose
            } = this.props;
        onClose(this.state.teamName, this.state.selectedManagerId);
    }

    updateName({ target }) {
        this.setState({ teamName: target.value });
    }

    selectSurveyFormType(surveyFormType) {
        this.setState({ surveyFormType: surveyFormType });
    }

    selectTeam = (teamId) => {
        this.setState({ selectedManagerId: teamId });
    }

    render() {
        const
            {
                domainValues
            } = this.props;
        if (!arrayIsNotEmpty(domainValues)) {
            return <div></div>;
        }
        const supervisorsDomain = domainValues.find(dv => dv.domainName === "Manager");
        const supervisors = (isDefined(supervisorsDomain) && arrayIsNotEmpty(supervisorsDomain.domainValues))
            ? [...supervisorsDomain.domainValues].sort((a, b) => {
                return a.domainValueName.localeCompare(b.domainValueName);
            }) : undefined;

        let textInput;
        return (<div className="modal displayBlock" >
            <div className="modal-content modal-create-team" ref={this.wrapperRef}>
                <div className="eighteen-regular-primary-color" >
                    Team Name
                </div>
                <div className="flex-container" style={{ margin: '20px auto' }}>
                    <TextInput
                        className="rectangle-18560"
                        id={"1"}
                        name={"min"}
                        onDOMChange={this.updateName}
                        value={textInput}
                    />
                </div>
                <div className="eighteen-regular-primary-color " style={{ margin: '17px 0 16px 0' }}>Manager:</div>
                <div className="bordered-div" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {supervisors.map(team => (
                        <div className="radio-button-text" key={team.domainValueId}>
                            <div style={{ margin: '10px' }}>
                                <RadioButton id={team.domainValueId} label={team.domainValueName} checked={this.state.selectedManagerId == team.domainValueId}
                                    onChange={() => this.selectTeam(team.domainValueId)} />
                            </div>
                        </div>
                    ))}
                </div>
                <div style={{ position: 'relative', margin: '17px 0 16px 0' }}>
                    <button className="create-survey-button" style={{ position: 'relative', margin: '0 auto' }}
                        onClick={this.closeAndCreate}>Create Team</button>
                </div>
            </div>
        </div>);
    };
}

const select = state => ({});

export default connect(select)(TeamEditor);

